import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ADTDashboard from './components/ADTDashboard';
import ESignDashboard from './components/ESignDashboard';
import Findhelp from './components/Findhelp';
import ICTPortal from './components/ICTPortal';
import MHint from './components/MHint';
import ServiceTable from './components/ServiceTable';
import SalesforceM360 from './components/SalesforceM360';
import SalesforcePCP from './components/SalesforcePCP';
import SSBCI from './components/SSBCI';
import MCare from './components/MCare';
import OptumImpactPro from './components/OptumImpactPro';
import InSignia from './components/InSignia';
import PegaLTSS from './components/PegaLTSS';
import CCAArchival from './components/CCAArchival';
import CustomReports from './components/CustomReports';
import QNXT from './components/QNXT';
import AIML from './components/AIML';
import MemberMerge from './components/MemberMerge';
import Health from './components/Health';
import Member360 from './components/Member360';
import PowerBICABright from './components/PowerBICABright';
import TCare from './components/TCare';
import Periscope from './components/Periscope';
import Trualta from './components/Trualta';
import ClinicalProfile from './components/ClinicalProfile';
import CareSync from './components/CareSync';
import AutonomizeNMCCP from './components/AutonomizeNMCCP';
import AutonomizeNMCCPReport from './components/AutonomizeNMCCPReport';
import EPE from './components/EPE';
import DNC from './components/DNC';
function App() {
    return (
        <div className="App">
            <Router>
                <Routes>
                    <Route path="/ADTDashboard" element={<ADTDashboard />} />
                    <Route path="/ESignDashboard" element={<ESignDashboard />} />
                    <Route path="/Findhelp" element={<Findhelp />} />
                    <Route path="/ICTPortal" element={<ICTPortal />} />
                    <Route path="/InSignia" element={<InSignia />} />
                    <Route path="/MHint" element={<MHint />} />
                    <Route path="/SalesforceM360" element={<SalesforceM360 />} />
                    <Route path="/SalesforcePCP" element={<SalesforcePCP />} />
                    <Route path="/SSBCI" element={<SSBCI />} />
                    <Route path="/MCare" element={<MCare />} />
                    <Route path="/OptumImpactPro" element={<OptumImpactPro />} />
                    <Route path="/PegaLTSS" element={<PegaLTSS />} />
                    <Route path="/ServiceTable" element={<ServiceTable />} />
                    <Route path="/CCAArchival" element={<CCAArchival />} />
                    <Route path="/QNXT" element={<QNXT />} />
                    <Route path="/CustomReports" element={<CustomReports />} />
                    <Route path="/AIML" element={<AIML />} />
                    <Route path="/MemberMerge" element={<MemberMerge />} />
                    <Route path="/Member360" element={<Member360 />} />
                    <Route path="/PowerBICABright" element={<PowerBICABright />} />
                    <Route path="/ui/health" element={<Health />} />
                    <Route path="/redirect" element={<ESignDashboard />} />
                    <Route path="/TCare" element={<TCare />} />
                    <Route path="/Periscope" element={<Periscope />} />
                    <Route path="/Trualta" element={<Trualta />} /> 
                    <Route path="/ClinicalProfile" element={<ClinicalProfile />} />
                    <Route path="/CareSync" element={<CareSync />} />                  
                    <Route path="/AutonomizeNMCCP" element={<AutonomizeNMCCP />} />
                    <Route path="/AutonomizeNMCCPReport" element={<AutonomizeNMCCPReport />} />
                    <Route path="/EPE" element={<EPE />} />
                    <Route path="/DNC" element={<DNC />} />
                    <Route path="/" element={
                        <Health />
                    } />
                </Routes>
            </Router>
        </div>
    );
}

export default App;
